/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import config from "config";
import Head from "next/head";
import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { bp, theme } from "theme";
import { useWindowResize } from "utils/hooks";
import { getUrlPath } from "utils/helpers";
import dynamic from "next/dynamic";
import TagManagerUtils from "utils/TagManager";
import { useRouter } from "next/router";
import { USER_PLATFORM } from "constants/tracking";
import {
	JobCity,
	JobArea,
	JobListJob,
	BreadCrumbDataType,
	JobCategory,
	FooterLinks,
} from "types/job";
import { TestimonialType } from "types/profile/ConnectionsType";
import { getFaqList } from "utils/JobListFaqUtils";
import getFooterContent from "utils/JobDetail/getFooterContent";
import useTrackWebSession from "hooks/useTrackWebSession";
import categoryData1 from "cms/category-data";
import departmentData from "cms/department-data";
import cityData1 from "cms/city-data";
import metaData from "cms/metadata-data";
import cityAreaMap from "cms/city-area-map";
import areaData1 from "cms/area-data";
import jobEntitiesData from "cms/job-entities-data";
import testimonialsData from "data/joblistTestimonials.json";
import { getFooterLinksV2, getPublicJobFeed } from "utils/apiClients";
import { buildBreadCrumbsData } from "utils/breadCrumbsHelpers";
import { JOBS_PER_PAGE } from "utils/constants";
import { getJobListMetaData } from "utils/getMetadata";
import JobFeed from "components/JobListingPageComponents/JobFeed";
import ParseJobListSlug from "utils/newJobListSlugUtils";
import { JobCompany } from "types/job/JobCompany";
import { mxpTrackSection } from "components/ThemedComponent/mixPannelEvents";
import { FilterJobType, SearchEntity } from "store/reducer/jobs/types";
import Layout from "components/Layout/Layoutv2";
import footerData from "cms/footer-data";
import { FooterData } from "types/job/FooterData";
import useMediaQuery from "hooks/useMediaQuery";
import { JobDepartment } from "types/job/JobDepartment";
import { isOnboardingComplete, isUserLoggedIn } from "utils";
import {
	FILTER_LABELS,
	FilterChoice,
	getSelectedFiltersList,
} from "components/JobListingPageComponents/FiltersSidebar/index";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import {
	generateSearchSessionID,
	getPrefilledLocation,
	getSearchEventProps,
	getSearchSessionID,
	setSearchEventProps,
} from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import DesktopFilters from "components/RevampFeedDetails/JobFeed/components/DesktopFilters";
import JoinTheCommunity from "components/NewerHomepage/JoinTheCommunity";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { LoginRefactoredContext } from "components/LoginRefactored/LoginContext";
import TickIcon from "assets/svgs/TickIcon";
import {
	MIN_EXPERIENCE_DEFAULT_VALUE,
	VALUE_TO_LABEL_MAPPING,
} from "components/RevampFeedDetails/constants";
import ExploreJobsInOthercity from "components/JobListingPageComponents/ExploreJobsInOtherCity/ExploreJobsInOthercity";
import { parseURLFilters } from "pages/candidate/jobs/[[...paths]]";
import useIntersectionObservers from "hooks/useIntersectionObservers";
import { jobsListTransformer } from "utils/jobFeedApiParser";
import { Correction } from "types/job/jobCorrectionType";
import { getFinalUrl } from "components/Search/Search";
import SearchCorrectionSubtitle from "components/Search/SearchCorrectionSubtitle";

const FooterSeoContent = dynamic(() => import("components/FooterSeoContent"));

// const WebToAppBanner = dynamic(() => import("components/CTA/WebToAppBanner"));

const FiltersSidebar = dynamic(
	() => import("components/JobListingPageComponents/FiltersSidebar/index")
);

const FilterChipsNew = dynamic(
	() => import("components/JobListingPageComponents/FilterChipsNew")
);

const SearchComponentMobile = dynamic(() => import("components/Search/SearchMobile"), {
	ssr: false,
	loading: () => <SkeletonUI />,
});

const SkeletonUI = () => (
	<div className="p-2">
		{/* Search Input Skeleton */}
		<div className="flex h-[50px] w-full animate-pulse items-center rounded-lg bg-[#f0f0f0] px-4">
			<div className="mr-2 h-4 w-4 rounded-full bg-[#e0e0e0]" />
			<div className="h-4 w-full rounded bg-[#e0e0e0]" />
		</div>

		{/* Text Skeleton */}
		<div className="mt-3">
			<div className="mb-2 h-5 w-full animate-pulse rounded-lg bg-[#f0f0f0]" />
			<div className="mb-2 h-5 w-full animate-pulse rounded-lg bg-[#f0f0f0]" />
		</div>
	</div>
);

export type JobsPropsType = {
	filters: {
		job_title_slug?: string;
		department: JobDepartment[];
		category: JobCategory[];
		city: JobCity[];
		area: JobArea[];
		location: { id: number; type: string; name: string; identifier: string };
		jobTypes: FilterJobType;
		company: JobCompany[];
		educationLevel: { level: number }[];
		gender: string;
		english_level: string;
		workType?: string[];
		workShift?: string[];
		distance?: string;
		postedIn: number;
		searchEntity?: SearchEntity;
		search?: boolean;
		min_experience: number;
		salary: string;
		sortBy?: string;
		others?: string;
		featured_jobs: boolean;
	};
	appliedFilterCount: number;
	categoryList: JobCategory[];
	departmentList: JobDepartment[];
	cityList: JobCity[];
	areaList: JobArea[];
	state: { id: number; name: string; slug: string };
	jobs: JobListJob[];
	testimonials: TestimonialType[];
	pageNumber: number;
	pageName: string;
	slug: string;
	footerContent: any; // TODO: improve types
	slugEntitiesDetails: any;
	pageTitle: string;
	metaTitle: string;
	metaDescription: string;
	footerLinks: FooterLinks[];
	breadCrumbData: BreadCrumbDataType[];
	faqs: { question: string; answer: string }[];
	query: {
		page: number;
		page_size: number;
		wfh?: number;
		part_time?: number;
		experience?: string;
		shift?: string;
		gender?: string;
		english_level?: string;
		education_level?: number;
		category_id?: number;
		company_id?: string;
		city_id?: number;
		area_id?: number;
		state_id?: number;
		fall_back_type?: string;
		search?: boolean;
		entity_type?: string;
		entity_id?: number;
		text?: string;
		location_id: string;
		location_identifier: string;
		location_type: string;
		location_name: string;
		featured_jobs: boolean;
	};
	totalJobCount: number;
	exploreByOtherCitiesData: any;
	paginationObject: any;
	correction: Correction | null;
};

const Jobs: React.FC<JobsPropsType> = ({
	filters,
	areaList = [],
	jobs,
	testimonials,
	pageNumber,
	slug,
	appliedFilterCount,
	slugEntitiesDetails,
	state = null,
	faqs,
	query,
	totalJobCount = 0,
	footerContent,
	breadCrumbData,
	exploreByOtherCitiesData = {},
	paginationObject,
	correction,
	...props
}) => {
	/**
	 * We show footer content which is used for purely seo purpose only if url
	 * is for city level jobs only e.g jobs-in-mumbai
	 */
	const router = useRouter();
	const { isIntersecting: showElement, elementRef: joinCommunityRef } =
		useIntersectionObservers({ threshold: 0.1, rootMargin: "20px" });
	const [activeFilter, setActiveFilterState] = useState(FilterChoice.SORT_BY);
	const isDesktop = useMediaQuery("(min-width: 768px)");
	const [hasUserScrolled, setHasUserScrolled] = useState(false);

	const {
		setJobs,
		jobsCount,
		totalJobsPages,
		setUrlSearchQuery,
		filters: desktopFilters,
		appliedFiltersCount: totalAppliedFilters,
		appliedFilters,
		setUrlPath,
		titleSearchObject,
		setExperienceSearchObject,
		manualUserSearchInputs,
		citySearchObject,
		setSlugEntityDetails,
		setIsDesktopSearchExpanded,
		setCitySearchObject,
		setTitleSearchObject,
		setFiltersInitialState,
		experienceSearchObject,
		resetFilters,
		searchCorrectionObject,
		setSearchCorrectionObject,
		setSearchSessionId,
	} = useJobFeedStore();
	const { page: desktopCurrentPage } = desktopFilters;

	const { category, city, area, location, department, searchEntity, min_experience } =
		filters;
	const { workFromHome, partTime, womenJobs, freshersJobs, nightShift } =
		filters.jobTypes;
	const [isMobileView] = useWindowResize();
	const isSearch = query?.search;
	useEffect(() => {
		const filtersToApply = parseURLFilters(filters);
		setFiltersInitialState([...filtersToApply]);
		if (min_experience && min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE) {
			setExperienceSearchObject({
				display_text: VALUE_TO_LABEL_MAPPING?.min_experience?.[min_experience],
				experience_input: min_experience,
			});
		}

		setJobs(jobs, totalJobCount || paginationObject?.total_size);
		setUrlSearchQuery(query);
		setSlugEntityDetails(slugEntitiesDetails[0]);
		setSearchCorrectionObject(correction);

		if (
			Array.isArray(slugEntitiesDetails) &&
			slugEntitiesDetails[0]?.type === "company"
		) {
			setUrlPath({
				company_id: slugEntitiesDetails[0]?.id,
			});
		}
		if (filters?.job_title_slug) {
			setUrlPath({ job_title_slug: filters?.job_title_slug });
		}
		if (
			Array.isArray(slugEntitiesDetails) &&
			slugEntitiesDetails[0]?.type === "gender"
		) {
			setUrlPath({
				gender: slugEntitiesDetails[0]?.filter?.split("=").join("-"),
			});
		}

		if (filters?.category[0]?.id > 0) {
			setUrlPath({ category_id: filters?.category[0]?.id });
		}
		// Parse city, area, location and search query data
		if (city[0]?.id > 0) {
			setCitySearchObject(city[0]);
		}
		// Check impact of change
		if (location?.id || location?.identifier) {
			setCitySearchObject(location);
		}
		if (searchEntity?.display_name) {
			if (searchEntity?.display_name !== titleSearchObject?.display_name)
				setTitleSearchObject(searchEntity);
		} else {
			setTitleSearchObject(null);
		}
	}, [
		jobs,
		totalJobCount,
		query,
		slugEntitiesDetails,
		city,
		location,
		searchEntity,
		min_experience,
	]);

	useEffect(() => {
		// generate a new searchSessionId only when search is initiated
		if (isSearch) {
			const searchId = generateSearchSessionID();
			setSearchSessionId(searchId);
		}
	}, []);

	useEffect(() => {
		// For search pages, we want to keep the search bar in expanded state for logged in and logged out users.
		if (isSearch && !isMobileView) setIsDesktopSearchExpanded(true);
	}, [isSearch, isMobileView]);
	const startAuth = useContext(LoginRefactoredContext);

	useLayoutEffect(() => {
		const searchEventObj = getSearchEventProps();
		if (
			!(searchEventObj && searchEventObj[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_SOURCE])
		) {
			const obj = {
				[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_SOURCE]: "Default",
			};
			const resObj = { ...searchEventObj, ...obj };
			setSearchEventProps(resObj);
		}
	}, []);
	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 75) {
				setHasUserScrolled(true);
			}
			if (window.scrollY <= 0) {
				setHasUserScrolled(false);
			}
		};
		if (isMobileView) window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const jobsData = jobs || [];

	const { metaTitle, metaDescription, pageName, footerLinks } = props;

	const isJobFeedPage = !isSearch && slugEntitiesDetails?.length === 0;
	useTrackWebSession(pageName);

	const isCityOnlyFeed = slugEntitiesDetails?.every(
		(e: { type: string }) => e.type === "city"
	);

	const [isShowFilterSidebar, setShowFilterSidebar] = useState(false);
	const [isShowSearchModal, setShowSearchModal] = useState(false);

	const commonTrackingObj = {
		Source: props.pageName,
		city: city[0]?.name || "All",
		area: area[0]?.name || "All",
		category: category[0]?.type || "All",
		department: department[0]?.type || "All",
		state: state?.name || "All",
		// company: company[0]?.name || "All",
		isLoggedIn: false,
		selectedJobFeedType: null,
		userPlatform: USER_PLATFORM.apna,
		page: getUrlPath(),
	};

	const handleAllFiltersClick = () => {
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track(`Filter Chip Click`, {
				...commonTrackingObj,
				Section: mxpTrackSection.HERO_SECTION,
				currentFilter: "All",
				selectedFilter: "All",
				pageNo: pageNumber,
			});
		});
		setShowFilterSidebar(true);
	};

	useEffect(() => {
		// const searchEventObj = getSearchEventProps();
		const prefilledLocation = getPrefilledLocation();
		if (isJobFeedPage) {
			import("utils/Mixpanel").then((Mixpanel) => {
				Mixpanel.default.track("Job Feed Web", {
					"distinct jobs count": isMobileView ? totalJobCount : jobsCount,
					"Selected Filters": getSelectedFiltersList(desktopFilters),
					"Is filter applied": isMobileView
						? !!appliedFilterCount
						: !!appliedFilters.length,
					"filters auto applied": null,
					"auto applied filters": null,
				});
			});
			return;
		}

		trackOnMixpanel("Search Query Fetched Web", {
			num_main_bucket_jobs: totalJobCount,
			"Zero Search Results": totalJobCount <= 0,
			num_other_bucket_jobs: 0,
			"User Entered Query": query?.text || "",
			"Entity Type": filters?.searchEntity?.entity_type || null,
			"User Entered Location Query": location?.name
				? location?.name
				: city[0]?.name || "Anywhere in India",
			"Location Type": location?.type ? location?.type : city[0]?.type || "Custom",
			"Location Search Feature Used": "Default",
			Web_Job_Source: "Job Search Web",
			// "Search Method": filters?.searchEntity?.display_name
			// 	? "Keyword_Location"
			// 	: "Location_only",
			is_sorting_applied_search: isMobileView
				? !!filters?.sortBy
				: !!desktopFilters.sort_by,
			is_filter_applied_search: isMobileView
				? appliedFilterCount > 0
				: !!appliedFilters?.length,
			filters_applied: isMobileView
				? appliedFilterCount > 0
				: !!appliedFilters.length,
			page_no: isMobileView ? router.query?.page : desktopFilters?.page,
			Prefilled_Location: prefilledLocation,
			"User entered experience in years":
				min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE ? min_experience : "N/A",
			"User entered experience":
				min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE && !!min_experience,
			"Is experience filter manually applied": manualUserSearchInputs?.experience
				? !!manualUserSearchInputs?.experience
				: "No",
			"Is location filter manually applied": manualUserSearchInputs?.location
				? !!manualUserSearchInputs?.location
				: "No",
			"Auto Suggested keyword": searchCorrectionObject?.corrected_text,
			"Suggestion type": searchCorrectionObject
				? searchCorrectionObject?.is_implicit
					? "implicit"
					: "explicit"
				: "none",
			"auto suggested entity id":
				searchCorrectionObject?.suggestion?.entity_id || "",
			"auto suggested entity type":
				searchCorrectionObject?.suggestion?.entity_type || "",
			"Search ID": router?.query?.search ? getSearchSessionID() : "",
		});
	}, [filters]);

	useEffect(() => {
		// eslint-disable-next-line camelcase
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Page View", {
				Source: pageName,
				pageType: "Job List",
				city: city[0]?.name || "All",
				area: area[0]?.name || "All",
				category: category[0]?.name || "All",
				state: state?.name || "All",
				page: getUrlPath(),
				workFromHome: Boolean(workFromHome),
				partTime: Boolean(partTime),
				womenJob: Boolean(womenJobs),
				freshersJob: Boolean(freshersJobs),
			});
		});

		TagManagerUtils.addDataLayer({
			category: category[0]?.type,
			area: area[0]?.name,
			city: city[0]?.name,
			workFromHome: Boolean(workFromHome),
			partTime: Boolean(partTime),
			womenJob: Boolean(womenJobs),
			freshersJob: Boolean(freshersJobs),
			Source: pageName,
			state: state?.name,
			// company: company[0]?.name,
		});
		trackOnMixpanel("Login card shown", {
			screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
		});
	}, []);

	const selectedFilter = () => {
		if (workFromHome) return "wfh";
		if (partTime) return "partTime";
		if (womenJobs) return "female";
		if (freshersJobs) return "freshers";
		if (nightShift) return "nightShift";
		return "";
	};

	const filteredJobsTitle = useMemo(() => {
		if (
			totalJobCount === 0 ||
			(searchCorrectionObject &&
				Object.keys(searchCorrectionObject).length !== 0 &&
				!searchCorrectionObject?.is_implicit)
		) {
			return "";
		}

		if (
			searchCorrectionObject &&
			Object.keys(searchCorrectionObject).length !== 0 &&
			isSearch &&
			searchCorrectionObject?.is_implicit
		) {
			return `Showing ${jobsCount} search results for ${searchCorrectionObject?.corrected_text}`;
		}

		const cityFilter = citySearchObject?.name;
		const isCityPresent = cityFilter?.id > 0 - 1 && cityFilter?.slug !== "all";

		const cityString = isCityPresent ? `in ${cityFilter?.name}` : "";
		const getStaticTitle = (staticTitle: string, resultCount: number) => {
			if (resultCount > 500) {
				return `500+ ${staticTitle} jobs ${cityString}`;
			}
			if (resultCount > 1) {
				return `${resultCount} ${staticTitle} jobs ${cityString}`;
			}

			return `${staticTitle} jobs ${cityString}`;
		};

		const slugToTitleMapping = {
			// qualification
			"10th_pass": (resultCount: number) =>
				getStaticTitle("10th pass", resultCount),
			"12th_pass": (resultCount: number) =>
				getStaticTitle("12th pass", resultCount),
			diploma: (resultCount: number) => getStaticTitle("Diploma", resultCount),
			iti: (resultCount: number) => getStaticTitle("ITI", resultCount),
			graduate: (resultCount: number) => getStaticTitle("Graduate", resultCount),
			post_graduate: (resultCount: number) =>
				getStaticTitle("Post Graduate", resultCount),

			// static
			work_from_home: (resultCount: number) =>
				getStaticTitle("Work from home", resultCount),
			part_time: (resultCount: number) => getStaticTitle("Part time", resultCount),
			freshers: (resultCount: number) => getStaticTitle("Freshers", resultCount),
			female: (resultCount: number) => getStaticTitle("Womens", resultCount),
			full_time: (resultCount: number) => getStaticTitle("Full time", resultCount),
			night_shift: (resultCount: number) =>
				getStaticTitle("Night Shift", resultCount),
		};

		let searchTitle = `${
			totalAppliedFilters
				? `Showing ${jobsCount > 500 ? `${500}+` : jobsCount} ${
						jobsCount === 1 ? "job" : "jobs"
				  } based on your ${totalAppliedFilters === 1 ? "filter" : "filters"}`
				: Object.keys(router.query).length
				? jobsCount
					? `${jobsCount > 500 ? `${500}+` : jobsCount} search ${
							jobsCount === 1 ? `result` : `results`
					  }`
					: ""
				: "Showing all jobs"
		}`;
		if (slug !== "" && slug !== "jobs") {
			const coreSlug = slug.split("-")[0];
			if (coreSlug in slugToTitleMapping) {
				searchTitle = slugToTitleMapping[coreSlug](jobsCount);
			} else if (department[0]?.id !== -1 && slug.includes("dep_")) {
				searchTitle = `Explore and Find your ideal ${department[0]?.name} job vacancies ${cityString}`;
			} else if (city[0]?.id !== -1 && slug.includes("jobs-in-")) {
				const cityName = city[0]?.name;
				searchTitle = `Jobs in ${cityName} : Explore & find the latest job vacancies in ${cityName}`;
			}
		}

		return searchTitle;
	}, [
		slug,
		appliedFilterCount,
		jobsCount,
		router.query,
		citySearchObject,
		searchCorrectionObject,
	]);

	// This helps in closing the FilterSideBar Component on click of browser's back button
	useEffect(() => {
		router.beforePopState(({ as }) => {
			if (as !== router.asPath) {
				if (isShowFilterSidebar) {
					setShowFilterSidebar(false);
				}
				if (isShowSearchModal) {
					setShowSearchModal(false);
				}
			}
			return true;
		});

		return () => {
			router.beforePopState(() => true);
		};
	}, [router.query]);

	useEffect(() => {
		if (isShowFilterSidebar) {
			document.body.style.overflow = "hidden";
			// router.push("#");
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isShowFilterSidebar]);

	useEffect(() => {
		if (isShowSearchModal) {
			document.body.style.overflow = "hidden";
			// router.push("#");
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isShowSearchModal]);

	const setActiveFilter = (filterState: FilterChoice) => {
		setActiveFilterState(filterState);
		setShowFilterSidebar(true);
	};
	const filterChipsList = useMemo(() => {
		const searchChipsList = [
			{
				label: FILTER_LABELS[FilterChoice.EXPERIENCE],
				count:
					desktopFilters?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE
						? 1
						: 0,
				onClick: () => setActiveFilter(FilterChoice.EXPERIENCE),
			},
			{
				label: FILTER_LABELS[FilterChoice.POSTED_IN],
				count: desktopFilters?.posted_in > 0 ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.POSTED_IN),
			},
			// For Search only add distance filter when search location query is non empty and of type "area"
			...((location?.type === "NBArea" || location?.type === "Area") &&
			location?.name !== ""
				? [
						{
							label: FILTER_LABELS[FilterChoice.DISTANCE],
							count: desktopFilters?.distance?.length ? 1 : 0,
							onClick: () => setActiveFilter(FilterChoice.DISTANCE),
						},
				  ]
				: []),
			{
				label: FILTER_LABELS[FilterChoice.SALARY],
				count: desktopFilters?.salary ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SALARY),
			},
			{
				label: FILTER_LABELS[FilterChoice.EDUCATION],
				count: desktopFilters?.education_level ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.EDUCATION),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_MODE],
				count: desktopFilters?.work_mode?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_MODE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_TYPE],
				count: desktopFilters?.work_type?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_TYPE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_SHIFT],
				count: desktopFilters?.work_shift?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_SHIFT),
			},
			{
				label: FILTER_LABELS[FilterChoice.DEPARTMENT],
				count:
					desktopFilters?.department_id?.[0] !== -1
						? desktopFilters?.department_id?.length
						: 0,
				onClick: () => setActiveFilter(FilterChoice.DEPARTMENT),
			},
			{
				label: FILTER_LABELS[FilterChoice.ENGLISH],
				count: desktopFilters?.english_level !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.ENGLISH),
			},
			{
				label: FILTER_LABELS[FilterChoice.GENDER],
				count: desktopFilters?.gender !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.GENDER),
			},
			{
				label: FILTER_LABELS[FilterChoice.SORT_BY],
				count: desktopFilters?.sort_by !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SORT_BY),
			},
			{
				label: FILTER_LABELS[FilterChoice.FEATURED],
				count: desktopFilters?.featured_jobs !== false ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.FEATURED),
			},
		];

		const feedChipsList = [
			{
				label: FILTER_LABELS[FilterChoice.POSTED_IN],
				count: desktopFilters?.posted_in > 0 ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.POSTED_IN),
			},
			// for FEED - only add distance filter when user is logged in and onboarded
			...(isUserLoggedIn() && isOnboardingComplete()
				? [
						{
							label: `${FILTER_LABELS[FilterChoice.DISTANCE]}`,
							count: desktopFilters?.distance?.length ? 1 : 0,
							onClick: () => setActiveFilter(FilterChoice.DISTANCE),
						},
				  ]
				: []),
			{
				label: FILTER_LABELS[FilterChoice.SALARY],
				count: desktopFilters?.salary ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SALARY),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_MODE],
				count: desktopFilters?.work_mode?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_MODE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_TYPE],
				count: desktopFilters?.work_type?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_TYPE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_SHIFT],
				count: desktopFilters?.work_shift?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_SHIFT),
			},
			{
				label: FILTER_LABELS[FilterChoice.DEPARTMENT],
				count:
					desktopFilters?.department_id?.[0] !== -1
						? desktopFilters?.department_id?.length
						: 0,
				onClick: () => setActiveFilter(FilterChoice.DEPARTMENT),
			},
			{
				label: FILTER_LABELS[FilterChoice.SORT_BY],
				count: desktopFilters?.sort_by !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SORT_BY),
			},
		];
		const list = isSearch ? searchChipsList : feedChipsList;
		const sortedList = list.sort((a, b) => b.count - a.count);
		return sortedList;
	}, [
		filters,
		desktopFilters,
		setActiveFilter,
		location,
		isSearch,
		isUserLoggedIn,
		isOnboardingComplete,
	]);

	/**
	 * In case a user is logged in, we ought to return null
	 * when he momentarily lands on this page, before app level redirection
	 * kicks in, so that there's no CLS.
	 */
	if (isUserLoggedIn()) {
		return null;
	}
	const onPageinationClick = () => {
		if (window) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};
	const handleCandidateLoginClick = () => {
		const screenType = "";
		startAuth();
		trackOnMixpanel("Login card clicked", {
			screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
		});

		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Candidate login", {
				page: getUrlPath(),
				Section: "Header",
				actionType: "Redirection",
				cta: "Candidate Website Login",
				Screen: screenType,
			});
		});
	};

	const handleSearchCorrection = () => {
		// Determine search text and query based on correction type
		const searchText = searchCorrectionObject?.is_implicit
			? query?.text
			: searchCorrectionObject?.text;
		const searchQuery = searchCorrectionObject?.is_implicit
			? query
			: searchCorrectionObject?.suggestion;

		// persisting previous search id and generating a new search id for analytics linking.
		const previousSearchSessionId = getSearchSessionID();
		const newSearchSessionId = generateSearchSessionID();
		setSearchSessionId(newSearchSessionId);

		trackOnMixpanel("search spellcheck correction clicked web", {
			"correction type": searchCorrectionObject?.is_implicit
				? "implicit"
				: "explicit",
			"user entered original query": query.text,
			"suggested query": searchCorrectionObject?.corrected_text,
			"user entered original location": location?.name || citySearchObject.name,
			num_main_bucket_jobs: totalJobCount,
			"orginal query entity": "",
			"suggested query entity":
				searchCorrectionObject?.suggestion?.entity_type || "",
			"Prev Search Id": previousSearchSessionId,
			"Search ID": newSearchSessionId,
		});

		resetFilters();

		// Generate final URL and navigate
		const url = getFinalUrl(
			searchQuery,
			citySearchObject,
			searchText,
			experienceSearchObject,
			searchCorrectionObject,
			newSearchSessionId
		);
		router.push(url);
	};

	return (
		<ThemeProvider theme={theme.apna}>
			<Layout
				title={metaTitle}
				metaDescription={metaDescription}
				metaTitle={metaTitle}
				source={pageName}
				slug={`/jobs${slug ? `/${slug}` : ""}${
					pageNumber > 1 ? `?page=${pageNumber}` : ""
				}`}
				staticFooter={false}
				dynamicFooterLinks={footerLinks}
				activePage="job"
				image={undefined}
				ogUrl={undefined}
				customUtmMedium={undefined}
				isDark={false}
				pageNumber={pageNumber}
				key={footerLinks?.[0]?.title}
				removeMarginFromFooter
				isSearch={isSearch}
				isJobListingPage
			>
				<Head>
					{pageNumber > 1 && (
						<link
							rel="prev"
							href={`${config.websiteUrl.slice(0, -1)}/jobs${
								slug ? `/${slug}` : ""
							}${pageNumber - 1 > 1 ? `?page=${pageNumber - 1}` : ""}`}
						/>
					)}
					{pageNumber < totalJobsPages && (
						<link
							rel="next"
							href={`${config.websiteUrl.slice(0, -1)}/jobs${
								slug ? `/${slug}` : ""
							}?page=${pageNumber + 1}`}
						/>
					)}
					<link rel="alternate" href="android-app://com.apnatime" />
				</Head>
				{/* Mobile -> Search and filters */}
				<div className="sticky top-16 z-10 block bg-white pb-2 shadow md:hidden">
					<SearchComponentMobile
						isShowSearchModal={isShowSearchModal}
						setShowSearchModal={setShowSearchModal}
					/>

					{/* Mobile jobs count title */}
					{!hasUserScrolled && jobsCount > 0 && (
						<div
							data-testid="search-result-title-container-mweb"
							className="mx-auto mt-[16px] max-w-[1040px] md:mb-[24px]"
						>
							<p className="m-0 mx-[12px] p-0 font-semibold leading-6 text-[#172b4d] md:text-xl md:leading-[28px]">
								{filteredJobsTitle}
							</p>
							{isSearch && searchCorrectionObject?.sub_title && (
								<p className="ml-[12px] text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
									<SearchCorrectionSubtitle
										correction={searchCorrectionObject}
										handleSearchCorrection={handleSearchCorrection}
										query={query}
									/>
								</p>
							)}
						</div>
					)}
					<FilterChipsWrapper>
						<FilterChipsNew
							handleAllFiltersClick={handleAllFiltersClick}
							filterObj={filterChipsList}
							isDesktopView={!isMobileView}
							departmentObject={department}
						/>
					</FilterChipsWrapper>
				</div>
				{/* Desktop jobs count title */}
				<div
					data-testid="search-result-title-container-web"
					className="mx-auto mt-[24px] hidden max-w-[1040px] md:mb-[24px] md:block"
				>
					<p className="m-0 font-semibold leading-6 text-[#172b4d] md:text-xl md:leading-[28px]">
						{filteredJobsTitle}
					</p>
					{isSearch && searchCorrectionObject?.sub_title && (
						<p className="m-0 text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
							<SearchCorrectionSubtitle
								correction={searchCorrectionObject}
								handleSearchCorrection={handleSearchCorrection}
								query={query}
							/>{" "}
						</p>
					)}
				</div>
				<div className="mx-auto grid max-w-[1040px] grid-cols-1 md:mb-16 md:grid-cols-4 md:gap-[16px]">
					{/* Filters Section for Desktop */}
					<div
						className={`hidden md:block  ${
							jobsData?.length > 0
								? "md:max-h-[4500px] md:min-h-[1880]"
								: "md:min-h-[1880px]"
						} md:w-[248px]`}
					>
						{!isMobileView && (
							<div className="col-span-1">
								<DesktopFilters location={location} />
							</div>
						)}
					</div>
					{/* Feed For Desktop and Mobile */}
					<div
						className={`col-span-1 md:col-span-2 ${
							jobsData?.length > 0
								? "min-h-auto md:max-h-[4500px] md:min-h-[1880px]"
								: "md:min-h-[1880px]"
						}`}
					>
						<JobFeed
							pageName={pageName}
							slug={slug}
							selectedState={state}
							isCityOnlyFeed={isCityOnlyFeed}
							filterStates={filters}
							pageNumber={desktopCurrentPage}
							filterCount={appliedFilterCount}
							search={filters?.search}
							onPageinationClick={onPageinationClick}
							isJobFeedPage={isJobFeedPage}
						/>
						<ExploreJobsInOthercity data={exploreByOtherCitiesData} />
					</div>
					{/* Banners Section */}
					{jobsCount >= 1 && (
						<div
							className={`p-4 first-line:bg-[#F4F2F6] md:col-span-1 ${
								jobsData?.length > 0
									? "md:max-h-[4500px] md:min-h-[1880px]"
									: "md:min-h-[1880px]"
							} md:p-0`}
						>
							<div className="h-full w-full rounded-xl">
								<div
									className="h-[450px] cursor-pointer rounded-xl  border border-[#C7DAF4] bg-[#F1F6FF] bg-job-bg bg-cover bg-center p-[16px] md:h-[412px]"
									onClick={handleCandidateLoginClick}
								>
									<div className="flex h-full flex-col justify-between">
										<div>
											<h2 className="mb-[16px] text-[20px] font-semibold leading-7 text-[#003C96]">
												Login with Apna and experience more !
											</h2>
											<ul className="m-0 p-0 text-[14px] leading-5 text-[#190a28]">
												<li className="mb-2 flex items-center md:mb-0">
													<img
														src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/check_2x.webp"
														alt=""
														width={13}
														height={13}
													/>
													<p className="ml-1 leading-5">
														Personalised job matches
													</p>
												</li>
												<li className="mb-2 flex items-center md:mb-0">
													<img
														src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/check_2x.webp"
														alt=""
														width={13}
														height={13}
													/>
													<p className="ml-1 leading-5">
														Direct connect with HRs
													</p>
												</li>
												<li className="mb-2 flex items-center md:mb-0">
													<img
														src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/check_2x.webp"
														alt=""
														width={13}
														height={13}
													/>
													<p className="ml-1 leading-5">
														Latest updates on the job
													</p>
												</li>
											</ul>
										</div>
										<button
											type="button"
											className="mt-[85px] flex w-full items-center justify-center rounded-[4px] bg-[#1F8368] p-[8px] text-center text-[14px] font-semibold leading-5 text-[#fff] md:p-[7px]"
										>
											<span>Create profile</span>
											<img
												src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/rightArrow.png"
												alt="arrow"
												height={8}
												width={6}
												className="ml-2"
											/>
										</button>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
				{slugEntitiesDetails?.length > 0 && (
					<FooterSeoContent content={footerContent} />
				)}
				<div ref={joinCommunityRef}>{showElement && <JoinTheCommunity />}</div>
			</Layout>
			<FiltersSidebar
				closeSidebar={() => {
					setShowFilterSidebar(false);
				}}
				activeFilterState={activeFilter}
				isShowFilterSidebar={isShowFilterSidebar}
				departmentObject={department}
			/>
		</ThemeProvider>
	);
};

export default Jobs;

export const getServerSideProps = async ({ params, query, res }) => {
	//  res.setHeader("Cache-Control", "public, s-maxage=43200, stale-while-revalidate");

	const { paths } = params;
	// eslint-disable-next-line prefer-const

	const slug = paths ? paths[0] : "";

	const pageNumber = query?.page ? parseInt(query?.page as string, 10) : 1;

	// If we do not get categorydata or area data we redirect user to  404 page
	// this check is added just in case if category data or area data api fails for some reason

	// if (categoryData1?.length === 0 || areaData1.length === 0 || metaData.length === 0) {
	// 	return {
	// 		notFound: true,
	// 	};
	// }

	const allObjectNew = {
		id: -1,
		type: "All",
		slug: "all",
		job_count: { total_jobs: 0, total_no_of_openings: 0 },
	};

	const defaultParamValue = {
		id: -1,
		name: "All",
		slug: "all",
	};

	const defaultArea = {
		id: -1,
		name: "All",
		slug: "all",
	};

	const defaultCity = {
		id: -1,
		name: "Anywhere in India",
		slug: "all",
	};

	let props = {
		filters: {
			city: [defaultCity],
			area: [defaultArea],
			location: { id: null, type: "", name: "", identifier: "" },
			category: [allObjectNew],
			department: [allObjectNew as unknown as JobDepartment],
			jobTypes: {
				partTime: 0,
				workFromHome: 0,
				nightShift: 0,
				freshersJobs: 0,
				womenJobs: 0,
			},
			salary: "",
			distance: "",
			postedIn: 0,
			educationLevel: [{ level: 0 }],
			company: [defaultParamValue],
			gender: "",
			english_level: "",
			searchEntity: null,
			search: false,
			job_title_slug: "",
			featured_jobs: false,
		},
		appliedFilterCount: 0,
		totalJobCount: 0,
		jobs: [],
		cityList: [defaultCity, ...(cityData1 as any)],
		categoryList: [allObjectNew, ...(categoryData1 as unknown as JobCategory[])],
		departmentList: [allObjectNew, ...(departmentData as unknown as JobDepartment[])],
		areaList: [],
		metaTitle: "",
		metaDescription: "",
		pageName: "Job Listing Page",
		isFallback: false,
		totalOpenings: 0,
		typeName: "",
		pageTitle: "",
		filter: {},
		totalPages: 0,
		breadCrumbData: null,
		slug,
		pageNumber,
		footerContent: {},
		footerLinks: [],
		slugEntitiesDetails: [],
		testimonials: [],
		state: defaultParamValue,
		faqs: [],
		query,
		exploreByOtherCitiesData: {},
		correction: {},
	};

	const { slugEntitiesDetails, filters, propsData, parsingFailed } = ParseJobListSlug(
		slug,
		pageNumber,
		JOBS_PER_PAGE,
		query,
		cityAreaMap,
		areaData1,
		jobEntitiesData,
		categoryData1,
		departmentData
	);

	if (!parsingFailed) {
		props = { ...props, ...propsData };

		props.query = {
			...props.query,
		};
		props.filter = {
			...query,
			...filters,
		};
		let appliedFilters = 0;

		if (
			propsData?.filters?.jobTypes?.freshersJobs ||
			propsData?.filters?.jobTypes?.nightShift ||
			propsData?.filters?.jobTypes?.partTime ||
			propsData?.filters?.jobTypes?.womenJobs ||
			propsData?.filters?.jobTypes?.workFromHome
		) {
			appliedFilters += 1;
		}

		if (
			propsData?.filters?.department?.length > 0 &&
			propsData?.filters?.department?.[0]?.id !== -1
		) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workMode?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workType?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workShift?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.educationLevel[0]?.level > 0) {
			appliedFilters += 1;
		}

		// if (propsData?.filters?.company[0]?.id !== -1) {
		// 	appliedFilters += 1;
		// }

		if (propsData?.filters?.salary?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.distance?.length > 0) {
			appliedFilters += 1;
		}

		if (
			propsData?.filters?.min_experience >= 0 &&
			propsData?.filters?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE
		) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.postedIn > 0 || propsData?.filters?.postedIn === -1) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.sortBy !== "") {
			appliedFilters += 1;
		}

		// if (propsData?.filters?.others !== "") {
		// 	appliedFilters += 1;
		// }
		if (propsData?.filters?.gender !== "") {
			appliedFilters += 1;
		}
		if (propsData?.filters?.english_level !== "") {
			appliedFilters += 1;
		}
		if (propsData?.filters?.featured_jobs) {
			appliedFilters += 1;
		}

		if (query?.raw_text_correction) {
			props.filter = {
				...props.filter,
				raw_text_correction: query?.raw_text_correction,
			};
		}

		props.appliedFilterCount = appliedFilters;

		props.breadCrumbData = buildBreadCrumbsData(slugEntitiesDetails);

		const footerContent = getFooterContent(
			footerData as unknown as FooterData,
			slugEntitiesDetails
		);

		props.footerContent = footerContent || null;
		props.slugEntitiesDetails = slugEntitiesDetails;
		try {
			const [jobResp, footerLinks] = await Promise.all([
				getPublicJobFeed(props.filter),
				getFooterLinksV2(props.filter),
			]);
			props.footerLinks = footerLinks.data;
			try {
				const faqs = getFaqList({
					city:
						propsData?.filters?.city[0]?.id === -1
							? undefined
							: propsData?.filters?.city[0],
					area:
						propsData?.filters?.area[0]?.id === -1
							? undefined
							: propsData?.filters?.area[0],
					category:
						propsData?.filters?.category[0]?.id === -1
							? undefined
							: propsData?.filters?.category[0],
					department:
						propsData?.filters?.department[0]?.id === -1
							? undefined
							: propsData?.filters?.department[0],
					footerLinks: footerLinks?.data,
					slug,
				});
				props.faqs = faqs || [];
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e, "faq error occured");
			}
			if (jobResp.status === 200) {
				// Get transformed jobs array and pagination object (for job feed)
				const { jobsList, pagination } = jobsListTransformer(
					jobResp?.data?.results
				);
				if (!jobResp?.data?.results?.jobs?.length) {
					res.statusCode = 404;
				}
				if (
					jobResp?.data?.count < filters?.soft_fall_back?.jobCountThreshold &&
					filters?.soft_fall_back?.url?.length > 0
				) {
					return {
						redirect: {
							statusCode: 302,
							destination: filters?.soft_fall_back?.url,
						},
					};
				}
				props.exploreByOtherCitiesData =
					jobResp?.data?.results?.explore_jobs_in_other_cities || {};
				// new props setup
				props.totalJobCount = jobResp?.data?.count || 0;
				props.totalPages = Math.ceil(props.totalJobCount / JOBS_PER_PAGE);
				props.totalOpenings =
					jobResp?.data?.results?.total_no_of_openings || props.totalJobCount;
				props.jobs = jobsList || [];
				props.paginationObject = pagination || null;
				props.isFallback = jobResp?.data?.results?.fall_back === "apply";
				props.typeName = jobResp?.data?.results?.type || "";
				props.correction = jobResp?.data?.results?.raw_text_correction;
				const { metaTitle, metaDescription, pageTitle, pageName } =
					await getJobListMetaData(
						slugEntitiesDetails,
						metaData,
						props.totalJobCount,
						slug
					);

				props.metaDescription = metaDescription;
				props.metaTitle = metaTitle;
				props.pageName = pageName;
				props.pageTitle = pageTitle;
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
			props.totalJobCount = 0;
			props.jobs = [];
		}

		/**
		 * we use local testiomnials data stored in json if its not older than 1 day
		 * otherwise we fetch testimonials from api which also update locally stored testimonials with new date
		 * so that subsequent requests dont need api calls
		 */

		if (testimonialsData) {
			props.testimonials = testimonialsData.testimonials;
		}

		return {
			props,
		};
	}
	return {
		notFound: true,
	};
};

const FilterChipsWrapper = styled.div`
	max-width: 1040px;
	margin: 0 auto;
	margin-top: 8px;
	background: #fff;
	${bp.md} {
		margin-top: 16px;
	}
`;

// const MobileWebToAppBanner = styled.div`
// 	display: block;
// 	position: sticky;
// 	bottom: 0;
// 	z-index: 21;
// 	${bp.md} {
// 		display: none;
// 	}
// `;
